import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "process-container"
};
const _hoisted_2 = {
  class: "el-pagination-wrap"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_card = _resolveComponent("el-card");
  const _component_process_info = _resolveComponent("process-info");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
    shadow: "hover"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.activeName = $event),
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        name: "0"
      }, {
        label: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-edit-outline"
        }), _createTextVNode(" 待审批")], -1)]))]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        name: "1"
      }, {
        label: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("span", null, [_createElementVNode("i", {
          class: "el-icon-s-check"
        }), _createTextVNode(" 已审批")], -1)]))]),
        _: 1
      }), _createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.queryParam.demandName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.queryParam.demandName = $event),
            size: "small",
            placeholder: "请输入需求名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "需求人",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.queryParam.userName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.queryParam.userName = $event),
            size: "small",
            placeholder: "请输入需求人"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.query
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("查询", -1)]))]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_el_button, {
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("重置", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "element-loading-text": "正在玩命加载中...",
        data: _ctx.processList,
        "header-cell-style": {
          background: '#FAFAFA'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "demandName",
          label: "需求名称"
        }), _createVNode(_component_el_table_column, {
          prop: "type",
          label: "需求类型"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(_ctx.demandType(scope.row)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "demandDep",
          label: "需求部门"
        }), _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "需求人"
        }), _createVNode(_component_el_table_column, {
          prop: "askTime",
          label: "申请时间"
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "联系方式"
        }), _createVNode(_component_el_table_column, {
          prop: "demandRemark",
          label: "需求备注",
          "show-overflow-tooltip": true
        }), _ctx.activeName === '1' ? (_openBlock(), _createBlock(_component_el_table_column, {
          prop: "approveResult",
          label: "审批结果",
          key: "1"
        }, {
          default: _withCtx(scope => [scope.row.approveResult === '1' ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "success",
            effect: "dark"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" 同意 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), scope.row.approveResult === '0' ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "danger",
            effect: "dark"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" 不同意 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), scope.row.approveResult === '2' ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "info",
            effect: "dark"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" 关闭 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [scope.row.status === '1' ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: $event => _ctx.handleView(scope.row),
            link: "",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("查看详情", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: $event => _ctx.handleAudit(scope.row),
            link: "",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("去审批", -1)]))]),
            _: 1
          }, 8, ["onClick"]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _ctx.loading]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "page-sizes": [10, 20, 30, 40, 50],
        "page-size": _ctx.paginationObj.pageSize,
        total: _ctx.paginationObj.totalSize,
        currentPage: _ctx.paginationObj.pageNo,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => _ctx.paginationObj.pageNo = $event),
        layout: "total,prev, pager, next, sizes, jumper"
      }, null, 8, ["onSizeChange", "onCurrentChange", "page-size", "total", "currentPage"])])]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: "流程详情",
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.dialogFormVisible = $event)
  }, _createSlots({
    default: _withCtx(() => [_createVNode(_component_process_info, {
      processInfo: _ctx.currentProcess,
      onCancel: _ctx.handleCancel,
      onSubmit: _ctx.handleSubmit
    }, null, 8, ["processInfo", "onCancel", "onSubmit"])]),
    _: 2
  }, [_ctx.currentProcess.status === '1' ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = $event => _ctx.dialogFormVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.dialogFormVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("确 定", -1)]))]),
      _: 1
    })])]),
    key: "0"
  } : undefined]), 1032, ["modelValue"])]);
}